/* menu-group.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswpfqs%7Bposition%3Astatic%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
import { SELECTION_STYLE_CONTEXT_DO_NOT_USE, SpacingContext } from '../internal/components/menu-context';
import type { MenuGroupProps } from '../types';
const baseStyles = null;

/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
const MenuGroup: (props: MenuGroupProps) => JSX.Element = ({
  isLoading,
  maxWidth,
  minWidth,
  minHeight,
  maxHeight,
  testId,
  role,
  spacing = 'cozy',
  menuLabel,
  // Although this isn't defined on props it is available because we've used
  // Spread props below and on the jsx element. To forcibly block usage I've
  // picked it out and supressed the expected type error.
  // @ts-expect-error
  className: UNSAFE_className,
  ...rest
}: MenuGroupProps) => <SpacingContext.Provider value={spacing}>
		<SELECTION_STYLE_CONTEXT_DO_NOT_USE.Provider value="border">
			<div aria-busy={isLoading} style={{
      minWidth,
      maxWidth,
      minHeight,
      maxHeight
    }} data-testid={testId} role={role}
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className={ax(["_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4", UNSAFE_className])} aria-label={menuLabel}
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    {...rest} />
		</SELECTION_STYLE_CONTEXT_DO_NOT_USE.Provider>
	</SpacingContext.Provider>;
export default MenuGroup;